import { inject, Injectable } from '@angular/core';
import { NotificationSnackbarService } from '@adcl/ngx-material';
import { TranslateService } from '@ngx-translate/core';
import { mobileSnackBarOption } from './notificationsnackbaroptions';

@Injectable({ providedIn: 'root' })
export class TranslatedNotificationService {
  private readonly snackbarService = inject(NotificationSnackbarService);
  private readonly translateService = inject(TranslateService);

  constructor() {}

  // Beachte, hier wird eine Methode als Paramteer übergeben und dann aufgerufen
  private showMessage(method: (msg: string, options: any) => void, text: string) {
    this.translateService.get(text).subscribe((res) => {
      method.call(this.snackbarService, res, mobileSnackBarOption);
    });
  }

  showSucessMessage(text: string) {
    this.showMessage(this.snackbarService.showSucessMessage, text);
  }

  showErrorMessage(text: string) {
    this.showMessage(this.snackbarService.showErrorMessage, text);
  }

  showWarningMessage(text: string) {
    this.showMessage(this.snackbarService.showWarningMessage, text);
  }
}
